export default {"src":"/_next/static/media/icon-work-time-new.e0b7915f.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};